import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 48 49",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M7 .55a7 7 0 0 0-7 7v34a7 7 0 0 0 7 7h34a7 7 0 0 0 7-7v-34a7 7 0 0 0-7-7zm31.106 10.885h-4.827l-7.948 8.567-6.873-8.567H8.505l11.892 14.664L9.124 38.247h4.827l8.7-9.373 7.605 9.373h9.71l-12.4-15.455zm-3.844 24.09h-2.673l-17.45-21.51h2.868z",
          "clip-rule": "evenodd",
        }),
      ]
    )
  );
}
